import { captchaStatusCodes } from '../constants';

export function isCaptchaError(statusCode: number) {
    return captchaStatusCodes.includes(statusCode);
}
